import { LoadingSpinner } from "./LoadingSpinner";
import { lazy, Suspense } from "react";

const AkindaAi = lazy(() => import("../UI/pages/AkindaAi"));
const Games = lazy(() => import("../UI/pages/Games"));

/** Akinda AI (embedded app) — same route on all viewports. */
export const AkindaAiRoute = () => (
  <Suspense fallback={<LoadingSpinner />}>
    <AkindaAi />
  </Suspense>
);


/** Daily games (embedded app) — same route on all viewports. */
export const GamesRoute = () => (
  <Suspense fallback={<LoadingSpinner />}>
    <Games />
  </Suspense>
);

// Dashboard and other placeholder components
export const Profile = () => <>it is empty</>;
export const WebsiteAnalytics = () => <>it is empty</>;
export const StockReport = () => <>it is empty</>;
export const SupportTickets = () => <>it is empty</>;

